/* ============================================
   Globdrop — Text normalisation for typed answers
   ============================================ */

/**
 * Normalise a typed answer or a stored name so they can be compared.
 *
 * - NFKC folds full-width Latin (ＵＳＡ) and half-width katakana first
 * - lower case, then NFD and drop Latin combining marks (é, ñ, ç, ü)
 * - drop Arabic short-vowel marks (harakat, U+064B–U+065F, and U+0670)
 * - hyphens become spaces; dots and apostrophes go; spaces collapse
 *
 * Japanese voiced marks (U+3099/U+309A) are kept on purpose: they change
 * the sound, so が and か stay different.
 */
export function normalizeText(text: string): string {
  return text
    .normalize('NFKC')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[ً-ٰٟ]/g, '')
    .replace(/[-‐‑–—]/g, ' ')
    .replace(/[.'’`]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Every spelling accepted for a flag: its names in each language, the part
 * of a name before a bracket and the part inside it ("United Nations (UN)"
 * accepts "United Nations" and "UN"), and any extra aliases in the data.
 */
export function acceptedAnswers(names: Record<string, string>, aliases: string[] = []): string[] {
  const answers: string[] = [];
  for (const name of Object.values(names)) {
    if (!name) continue;
    answers.push(name);
    const bracket = name.match(/^(.*?)\s*\((.+)\)\s*$/);
    if (bracket) answers.push(bracket[1]!, bracket[2]!);
  }
  return [...answers, ...aliases];
}
